<div
  class="cb-battle"
  [class.nuclear]="battle().mode === 'nuclear'"
  [class.equity]="battle().mode === 'equity'"
  [class.crazy]="battle().mode === 'crazy'"
  [class.normal]="battle().mode === 'normal'"
>
  @if (((animation() === 'finished' || animation() === 'battle-results')) ||
  !!battle()._replay || (!!battle()._replay && animation() === 'tie')) {
  <!--  -->
  @let isBattleRunning = animation() !== 'finished' && animation() !==
  'battle-results';
  <button
    @fadeInAnimation
    class="cb-battle--repeat-button"
    (click)="replayBattle.emit()"
    [disabled]="isBattleRunning"
  >
    <svg-icon
      class="flex items-center justify-center"
      [class.running]="isBattleRunning"
      [svgStyle]="{ width: '18px', height: '18px' }"
      src="assets/icons/ui/refresh.svg"
    ></svg-icon>
    <span> Replay </span>
  </button>
  }
  <app-cb-cases-progress
    [@fadeInOutAnimation]
    class="cb-battle--cases"
    [battle]="battle()"
    [balance]="balance()"
    [settings]="casesProgressSettings()"
  ></app-cb-cases-progress>

  <div class="cb-battle__actions">
    <button
      class="cb-battle--share"
      (click)="clipboardService.copy(battle().uid, 'Battle link copied')"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/shared/share.svg"
      />
      Share
    </button>
  </div>
  @if (battle().private) {
  <button
    class="cb-battle--private"
    type="button"
    [ngpTooltipTrigger]="tooltip"
    [ngpTooltipTriggerHideDelay]="0"
  >
    Private Battle
    <svg-icon
      class="flex items-center justify-center s-14"
      src="assets/icons/shared/info.svg"
    ></svg-icon>
  </button>
  <ng-template #tooltip>
    <div class="tooltip flex flex-col" ngpTooltip>
      @if (battle().cover > 0 ) {

      <div class="typography-tooltip">
        <span class="typography-tooltip" style="font-weight: bold"
          >{{ battle().cover }}%</span
        >
        sponsored by
        <span class="typography-tooltip" style="font-weight: bold">{{
          battle().host_name
        }}</span>
      </div>
      }
      <!--  -->
      @if (battle().afilter_text && battle().afilter_text !== '0d'){
      <div class="typography-tooltip">
        Only allowed for affiliators that deposited
        <span class="typography-tooltip" style="font-weight: bold">
          {{
            battle().depofilter > 0
              ? (battle().depofilter | currency : "USD" : "symbol")
              : "any amount"
          }}
        </span>
        in the last
        <span class="typography-tooltip" style="font-weight: bold">
          {{ AFFILIATE_TIME[battle().afilter_text] }}.
        </span>
      </div>
      }
    </div>
  </ng-template>
  }

  <app-cb-list-mode
    class="cb-battle__mode"
    [game]="battle()"
    [animation]="animation()"
  ></app-cb-list-mode>
  <div
    class="cb-battle--cost"
    (click)="animation() === 'finished' ? rehostBattle.emit() : null"
  >
    {{ animation() === "finished" ? "re-create battle" : "battle cost:" }}
    <app-cost
      [gap]="4"
      [cost]="battle().value"
      [color]="
        battle().mode === 'nuclear'
          ? 'var(--case-battle-nuclear)'
          : battle().mode === 'equity'
          ? 'var(--case-battle-equity)'
          : battle().mode === 'crazy'
          ? 'var(--case-battle-crazy)'
          : battle().mode === 'normal'
          ? 'var(--case-battle-normal)'
          : 'var(--yellow)'
      "
      [balanceType]="balance()"
    />
  </div>
  <div class="cb-battle__bottom">
    <div class="cb-battle--round-cost">
      Round cost:
      <span class="flex items-center gap-4">
        <app-balance-icon
          [balance]="balance()"
          [color]="
            battle().mode === 'nuclear'
              ? 'var(--case-battle-nuclear)'
              : battle().mode === 'equity'
              ? 'var(--case-battle-equity)'
              : battle().mode === 'crazy'
              ? 'var(--case-battle-crazy)'
              : battle().mode === 'normal'
              ? 'var(--case-battle-normal)'
              : null
          "
        ></app-balance-icon>
        <number-flow style="color: currentColor" #roundCost></number-flow>
      </span>
    </div>
    <div class="cb-battle--rounds">
      <span class="flex items-center gap-4">
        Rounds:
        <number-flow style="color: currentColor" #currentRound></number-flow>
        <span>/</span>
        {{ battle().cases.length }}
      </span>
    </div>
  </div>
</div>
